var React = require('react');

function CommonIcnTwitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27.4249 21.5785L40.8267 6H37.6509L26.0141 19.5266L16.7198 6H6L20.0548 26.4546L6 42.7911H9.17598L21.4647 28.5065L31.2802 42.7911H42L27.4241 21.5785H27.4249ZM23.0749 26.6348L21.6509 24.598L10.3203 8.39083H15.1984L24.3424 21.4705L25.7664 23.5074L37.6524 40.509H32.7743L23.0749 26.6356V26.6348Z","fill":"white"}));
}

CommonIcnTwitter.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = CommonIcnTwitter;

CommonIcnTwitter.default = CommonIcnTwitter;
